import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  cultivationDelete: {
    status: "idle",
    success: false,
  },
}

export const deleteData = createAsyncThunk('delete', async (data) => {
    const {token, model, crop, deletedTask} = data
    let payload = JSON.stringify({
        Name: model,
        Crop: crop,
        Action: deletedTask,
    })
    const axios = require("axios")
    const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/data/cultivation/YILI/delete` 

      const response = await axios.post(url,
                 payload,
                 { headers })
      return response.data
})

const cultivationDeleteSlice = createSlice({
  name: 'delete',
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [deleteData.pending.type]:(state, action) => {
      state.cultivationDelete = {
        status: "loading",
        success: 0,
      }
    },
    [deleteData.fulfilled.type]:(state, action) => {
      state.cultivationDelete = {
        status: "idle",
        success: action.payload.status,
      }
    },
    [deleteData.rejected.type]:(state, action) => {
      state.cultivationDelete = {
        status: "idle",
        success: 0,
      }
    },
  }
})

export default cultivationDeleteSlice.reducer
